import Base from "./_BaseComponent";
import $ from "jquery";

class ConnectRegister extends Base.Component {
	private formWrapper: JQuery;

	public onMount(): void {
		const _this = this;
		this.formWrapper = this.element.find("[data-bind=register-form]");
		this.element.find("[data-trigger=register]").on("click", this.onTriggerRegister.bind(this));
		this.element.find(".form-body [name]").on("change blur", function(e) {
			_this.buildMessage($(this).val());
		});
	}

	private onTriggerRegister(e: Event) {
		if (e)
			e.preventDefault();

		this.formWrapper.show();
		this.formWrapper.get(0).scrollIntoView();
		this.formWrapper.find("[name=name]").focus();
	}

	private buildMessage(val: any) {
		const features: Array<string> = [];
		this.element.find("[data-connect-feature]").each(function() {
			const feature = $(this).attr("data-feature").trim();
			if ($(this).is(":checked"))
				features.push(feature);
		});
		const newVal = `I would like to request a TillingConnect account.

		Company: ${this.element.find("[name=company]").val()}
		Position: ${this.element.find("[name=position]").val()}
		Sales Rep: ${this.element.find("[name=rep]").val()}
		Account Number: ${this.element.find("[name=account_number]").val()}
		Access level required: ${features.join(", ")}
		`;

		this.element.find("[name=message]").val(newVal);
	}

}

export default Base.Init("[data-component-connect-register]", ConnectRegister);
